module.exports = __webpack_public_path__ + "static/media/form-icon.3cb0a520.svg";